import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { DolapDetayIcerik } from './dolap-detay-icerik.js';
import { useDolap } from './api.js';

/**
 * Standalone dolap detay sayfası — direkt URL ile erişim (paylaşılabilir link).
 * Nokta detayından modal olarak açıldığında DolapDetayPenceresi kullanılır.
 */
export function SayfaDolapDetay() {
  const { id } = useParams({ strict: false }) as { id: string };
  const navigate = useNavigate();
  const sorgu = useDolap(id);

  const noktaId = sorgu.data?.noktaId;
  const noktaKod = sorgu.data?.noktaKod;

  return (
    <div className="space-y-6">
      {noktaId ? (
        <Link
          to="/panel/noktalar/$id"
          params={{ id: noktaId }}
          className="text-fume-500 hover:text-fume-800 dark:hover:text-fume-100 inline-flex items-center gap-1 text-sm"
        >
          <ArrowLeft size={14} /> {noktaKod ?? 'Nokta'} dolapları
        </Link>
      ) : (
        <Link
          to="/panel/noktalar"
          className="text-fume-500 hover:text-fume-800 dark:hover:text-fume-100 inline-flex items-center gap-1 text-sm"
        >
          <ArrowLeft size={14} /> Noktalar
        </Link>
      )}

      <DolapDetayIcerik
        dolapId={id}
        onSilSonra={() => {
          if (noktaId) {
            void navigate({ to: '/panel/noktalar/$id', params: { id: noktaId } });
          } else {
            void navigate({ to: '/panel/noktalar' });
          }
        }}
      />
    </div>
  );
}
